import AttachmentPreviewMode from './store/schema/AttachmentPreviewMode';
import PendingOperationState from './store/schema/PendingOperationState';
import PreviewPaneSelectionSource from './store/schema/PreviewPaneSelectionSource';
import SxSEditState, { EditMode } from './store/schema/SxSEditState';
import SxSExtendedViewState, { SaveToCloudStatus } from './store/schema/SxSExtendedViewState';
import {
    SxSConversationReadingPaneState,
    SxSItemReadingPaneState,
    SxSReadingPaneMode,
} from './store/schema/SxSReadingPaneState';
import SxSStore, { SxSCustomization } from './store/schema/SxSStore';
import * as SxSEventNames from './utils/eventNames';
import isAnySxSDisplayed from './utils/isAnySxSDisplayed';
import isSxSDisplayed, {
    isSxSDisplayedAndShouldHideConversationReadingPane,
    isSxSDisplayedForAttachment,
    isSxSDisplayedWithCompose,
} from './utils/isSxSDisplayed';
import { AttachmentPreviewMethod } from 'owa-attachment-data';
import { LazyAction, LazyImport, LazyModule } from 'owa-bundling';
import { ClientAttachmentId, ClientItemId } from 'owa-client-ids';
import { ImageGalleryItem } from 'owa-sxsdata';

const lazyModule = new LazyModule(() => import(/* webpackChunkName: "SxS" */ './lazyIndex'));

export const lazySxSStoreModule = new LazyImport(lazyModule, m => m);

export const lazyCanCloseSxS = new LazyImport(lazyModule, m => m.canCloseSxS);
export const lazyCloseComposeInSxS = new LazyImport(lazyModule, m => m.closeComposeInSxS);
export const lazyCreateImageGalleryFromAttachmentViewStateIds = new LazyImport(
    lazyModule,
    m => m.createImageGalleryFromAttachmentViewStateIds
);
export const lazyEditAndReply = new LazyImport(lazyModule, m => m.editAndReply);
export const lazyEditInDraft = new LazyImport(lazyModule, m => m.editInDraft);
export const lazyForceCloseSxS = new LazyImport(lazyModule, m => m.forceCloseSxS);
export const lazyLogUsageWithSxSCustomData = new LazyAction(
    lazyModule,
    m => m.logUsageWithSxSCustomData
);
export const lazyOnBeforeImageGalleryItemSelected = new LazyImport(
    lazyModule,
    m => m.onBeforeImageGalleryItemSelected
);
export const lazyOnChangeByImageGallery = new LazyImport(lazyModule, m => m.onChangeByImageGallery);
export const lazyOnSxSReadingPaneChange = new LazyImport(lazyModule, m => m.onSxSReadingPaneChange);
export const lazyOnPendingNavigation = new LazyImport(lazyModule, m => m.onPendingNavigation);
export const lazyOnPreviewOperationFinished = new LazyImport(
    lazyModule,
    m => m.onPreviewOperationFinished
);
export const lazyOnPreviewOperationStart = new LazyImport(
    lazyModule,
    m => m.onPreviewOperationStart
);
export const lazyOpenComposeInSxS = new LazyImport(lazyModule, m => m.openComposeInSxS);
export const lazyReloadTextPreview = new LazyImport(lazyModule, m => m.reloadTextPreview);
export const lazyShowSxS = new LazyImport(lazyModule, m => m.showSxS);
export const lazyTryCloseSxS = new LazyImport(lazyModule, m => m.tryCloseSxS);
export const lazyTryExitSxSEditMode = new LazyImport(lazyModule, m => m.tryExitSxSEditMode);

export { reloadReadingPaneAfterClosingSxS, onSxSChangeOrClose } from './actions/publicActions';

export { default as closeAllSxS } from './utils/closeAllSxS';
export { default as sxsStore } from './store/Store';
export {
    AttachmentPreviewMethod,
    AttachmentPreviewMode,
    ClientAttachmentId,
    ClientItemId,
    EditMode,
    ImageGalleryItem,
    isAnySxSDisplayed,
    isSxSDisplayed,
    isSxSDisplayedAndShouldHideConversationReadingPane,
    isSxSDisplayedForAttachment,
    isSxSDisplayedWithCompose,
    PendingOperationState,
    PreviewPaneSelectionSource,
    SaveToCloudStatus,
    SxSConversationReadingPaneState,
    SxSCustomization,
    SxSEditState,
    SxSEventNames,
    SxSExtendedViewState,
    SxSItemReadingPaneState,
    SxSReadingPaneMode,
    SxSStore,
};
